// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  creditos: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  kanban: getIcon('ic_kanban')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Estrategia',
    items: [
      /*{
        title: 'app',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      },*/
      // { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      /*{ title: 'Creditos', path: PATH_DASHBOARD.general.creditos, icon: ICONS.creditos },*/
      { title: 'Proyectos', path: PATH_DASHBOARD.general.proyects, icon: ICONS.analytics },
      { title: 'OKR', path: PATH_DASHBOARD.general.okrs2, icon: ICONS.analytics }
    ]
  },
  {
    subheader: 'Gestión',
    items: [{ title: 'Asana', path: PATH_DASHBOARD.general.asana, icon: ICONS.analytics }]
  },

  {
    subheader: 'Catalogos',
    items: [
      { title: 'Micro Bots', path: PATH_DASHBOARD.general.microbots, icon: ICONS.chat },
      { title: 'Soluciones', path: PATH_DASHBOARD.general.servicios, icon: ICONS.cart }
    ]
  },
  {
    subheader: 'interacciones',
    items: [{ title: 'Call to Actions', path: PATH_DASHBOARD.general.calltoactions, icon: ICONS.cart }]
  },
  {
    subheader: 'deprecado',
    items: [{ title: 'OKRS', path: PATH_DASHBOARD.general.okrs, icon: ICONS.analytics }]
  }
  /*{
    subheader: 'Experimantales',
    items: [
      {
        title: 'app',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      },

      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      { title: 'Hubspot', path: PATH_DASHBOARD.general.hubspot, icon: ICONS.cart },
      { title: 'Vision Artificial', path: PATH_DASHBOARD.general.VA, icon: ICONS.mail },
      { title: 'Animaciones inteligentes', path: PATH_DASHBOARD.general.Three, icon: ICONS.user }
    ]
  },*/
  // MANAGEMENT
  // ----------------------------------------------------------------------
  /*{
    subheader: 'management',
    items: [
      // MANAGEMENT : USER
      {
        title: 'user',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        children: [
          { title: 'profile', path: PATH_DASHBOARD.user.profile },
          { title: 'cards', path: PATH_DASHBOARD.user.cards },
          { title: 'list', path: PATH_DASHBOARD.user.list },
          { title: 'create', path: PATH_DASHBOARD.user.newUser },
          { title: 'edit', path: PATH_DASHBOARD.user.editById },
          { title: 'account', path: PATH_DASHBOARD.user.account }
        ]
      },*/

  // MANAGEMENT : E-COMMERCE
  /*{
    subheader: 'e-commerce',
    items: [
      { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
      { title: 'product', path: PATH_DASHBOARD.eCommerce.productById },
      { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
      { title: 'create', path: PATH_DASHBOARD.eCommerce.newProduct },
      { title: 'edit', path: PATH_DASHBOARD.eCommerce.editById },
      { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
      { title: 'invoice', path: PATH_DASHBOARD.eCommerce.invoice }
    ]
  }*/

  // MANAGEMENT : BLOG
  /*{
        title: 'blog',
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: 'posts', path: PATH_DASHBOARD.blog.posts },
          { title: 'post', path: PATH_DASHBOARD.blog.postById },
          { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
        ]
      }
    ]
  },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      { title: 'mail', path: PATH_DASHBOARD.mail.root, icon: ICONS.mail },
      { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
      { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban }
    ]
  }*/
];

export default sidebarConfig;
